module.exports = __webpack_public_path__ + "media/images/themes/light/fighting-donkeys-eccefb1f0155e5a5c473755b3659e437.gif";